import { useEffect, useState } from "react";
import { auth } from "../../firebase/firebase";
import { argosApiEntryPoint } from "../../GlobalConfig";
import { DehydratedRetractionWork } from "../CommonInterfaces";
import { LinearProgress, TableContainer, Paper, Table, TableHead, TableRow, TableCell, TableBody } from "@mui/material";
import { Link } from "react-router-dom";
import DoiAnalysisLink from "../DoiAnalysisLink";

interface RetractionsForOpenAlexAuthorProps {
    authorProfileId: string
    authorDisplayName: string
    institutionId: string | undefined,
    collaborationMode: boolean
}

function RetractionsForOpenAlexAuthor({ authorProfileId, authorDisplayName, institutionId, collaborationMode }: RetractionsForOpenAlexAuthorProps) {

    const [isLoading, setIsLoading] = useState(true)
    const [dehydratedRetractionWork, setDehydratedRetractionWork] = useState<DehydratedRetractionWork[]>([])
    const [doiAnalysisLoading, setDoiAnalysisLoading] = useState(false)

    useEffect(() => {

        setIsLoading(true)

        async function fetchData() {
            let authToken = await auth.currentUser?.getIdToken(true)

            fetch(argosApiEntryPoint + '/retraction/author/openalexid/'
                + authorProfileId.replaceAll("https://openalex.org/", "")
                + ((institutionId === undefined) ? '' : '?filter=institutionId:' + institutionId)
                + (collaborationMode === true ? '&useInstitutionForCollaborations=true' : '')
                , {
                    method: 'GET',
                    headers: {
                        'content-type': 'application/json;charset=UTF-8',
                        'Authorization': 'Bearer ' + authToken
                    }
                })
                .then((response) => response.json())
                .then((data: DehydratedRetractionWork[]) => {
                    setDehydratedRetractionWork(data)
                    setIsLoading(false)
                }
                );
        }
        fetchData()
    }, [authorProfileId]);

    return <>
        {isLoading && <LinearProgress />}
        {!isLoading &&
            <TableContainer component={Paper}>
                <Table sx={{ minWidth: 650 }} size="small" aria-label="a dense table">
                    <TableHead>
                        <TableRow>
                            <TableCell>DOI</TableCell>
                            <TableCell>Title</TableCell>
                            <TableCell>Journal</TableCell>
                            <TableCell>Publication Date</TableCell>
                            <TableCell>Retraction Date</TableCell>
                        </TableRow>
                    </TableHead>
                    <TableBody>
                        {dehydratedRetractionWork.map((row) => (
                            <TableRow
                                key={row.originalPaperDoi}
                                sx={{ '&:last-child td, &:last-child th': { border: 0 } }}
                            >
                                <TableCell>
                                    <DoiAnalysisLink
                                        doi={row.originalPaperDoi} newRetractions={[]}
                                        showDoiInTitle={true}
                                        whenLoading={() => setDoiAnalysisLoading(true)}
                                        whenLoaded={() => setDoiAnalysisLoading(false)}
                                    />
                                </TableCell>
                                <TableCell>
                                    {row.title}
                                </TableCell>
                                <TableCell>
                                    {row.journal}
                                </TableCell>
                                <TableCell>
                                    {row.originalPaperDate}
                                </TableCell>
                                <TableCell>
                                    {row.retractionDate}
                                </TableCell>
                            </TableRow>
                        ))}
                    </TableBody>
                </Table>
            </TableContainer>}
    </>
}

export default RetractionsForOpenAlexAuthor;